/**
 * Default Kanban stages seeded on org creation (seeker module).
 *
 * Declined is a closed stage like Closed, so everything that groups stages
 * by category still files it with the finished grants. What sets it apart
 * is `outcome`: Closed means a grant that ran its course, Declined means an
 * application the funder turned down. Without its own column a decline
 * could only be dragged to Closed, which recorded it as a completed grant
 * and counted it as a win. It comes after Closed so that anything picking
 * "the first closed stage" for a completed grant still lands on Closed.
 *
 * Workspaces created before this have no Declined stage. The board offers
 * to add one rather than this list being re-seeded, because those
 * workspaces may have renamed, reordered or built their own stages.
 */
export const DEFAULT_STAGES = [
    { name: 'Researching', color: '#94a3b8', category: 'pipeline' },
    { name: 'Preparing', color: '#60a5fa', category: 'pipeline' },
    { name: 'Submitted', color: '#a78bfa', category: 'pipeline' },
    { name: 'Awarded', color: '#34d399', category: 'active' },
    { name: 'Reporting Due', color: '#fbbf24', category: 'active' },
    { name: 'Closed', color: '#64748b', category: 'closed' },
    { name: 'Declined', color: '#fb7185', category: 'closed', outcome: 'declined' },
];
/** The Declined column, for a workspace whose stages predate it. */
export const DECLINED_STAGE = DEFAULT_STAGES[DEFAULT_STAGES.length - 1];
/** Application status machine for the Grantmaker Suite intake funnel. */
export const APPLICATION_STATUSES = [
    'submitted',
    'auto_screened',
    'screened_out',
    'shortlisted',
    'due_diligence',
    'recommended',
    'board_pending',
    'approved',
    'declined',
];
/**
 * Tranche lifecycle.
 *
 * Outgoing (grantmaker):
 *   pending_conditions → evidence_submitted → cleared → released
 *                                           ↘ withheld
 *   A tranche created with no conditions starts at `cleared`. Only
 *   `cleared` tranches can be batched, and only approveDisbursement can
 *   write `released`.
 *
 * Incoming (seeker): pending_conditions ("expected") → received.
 */
export const TRANCHE_STATUSES = [
    'pending_conditions',
    'evidence_submitted',
    'cleared',
    'released',
    'withheld',
    'received',
];
export const TRANCHE_STATUS_LABELS = {
    pending_conditions: 'Awaiting conditions',
    evidence_submitted: 'Evidence submitted',
    cleared: 'Cleared for payment',
    // Approval, not payment: see trancheLabel in labels.ts.
    released: 'Approved for payment',
    withheld: 'Withheld',
    received: 'Received',
};
